import {useMemo, useState} from "react";
import {useHistory} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {BasicTable, SearchBox} from "components/Table";
import {ButtonAddTable} from "components/Button";
import {useStaffs} from "hooks/SuperAdmin/Staff";
import {isMobile} from "react-device-detect";
import {ModalConfirmation} from "components/Modal";
import {useStateCallback} from "hooks/useStateCallback";
import {useDeleteStaff} from "hooks/SuperAdmin/Staff";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";

export function StaffListPage() {
	const [dataLimit, setDataLimit] = useState(10);
	const [searchKeyword, setSearchKeyword] = useState("");
	const {staffs, isLoading, filterStaffs} = useStaffs();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [deleteItemData, setDeleteItemData] = useStateCallback({id: null, name: null});
	const {mutate: deleteStaffById, isLoading: isDeletingData} = useDeleteStaff();
	const {showToast} = useToast();

	const history = useHistory();
	const columns = useMemo(
		() => [
			{
				Header: "No",
				accessor: "idSerial",
			},
			// {
			// 	Header: "Status Karyawan",
			// 	accessor: "staff.employeeStatusText",
			// },
			{
				Header: "Kode NIP",
				accessor: "staff.nip",
			},
			{
				Header: "Nama Karyawan",
				accessor: "firstName",
				Cell: ({row}) => <>{`${row?.original?.firstName} ${row?.original?.lastName}`}</>,
				maxWidth: 150,
			},
			{
				Header: "No Telp",
				accessor: "phoneNumber",
			},
			{
				Header: "Usia",
				accessor: "dobText",
				Cell: ({row}) => row?.values?.["dobText"] || "-",
			},
			{
				Header: "Aksi",
				accessor: "id",
				Cell: ({row}) => (
					<>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/staff/show/${row?.original?.staff?.id}`)}>
							<span class="icon-ico-eye-open ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/staff/edit/${row?.original?.staff?.id}`)}>
							<span class="icon-ico-pencil ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => {
								setDeleteItemData(row?.original, () => setShowDeleteModal(true));
							}}>
							<span class="icon-ico-delete ft-18" />
						</a>
					</>
				),
			},
		],
		[],
	);

	const columnsMobile = useMemo(
		() => [
			{
				Header: "Nama Karyawan",
				accessor: "firstName",
				Cell: ({row}) => (
					<div class="col-9">
						<div class="text-bold">{`${row?.original?.firstName} ${row?.original?.lastName}`}</div>
					</div>
				),
			},
			{
				Header: "Aksi",
				accessor: "id",
				Cell: ({row}) => (
					<>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/staff/show/${row?.original?.staff?.id}`)}>
							<span class="icon-ico-eye-open ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/staff/edit/${row?.original?.staff?.id}`)}>
							<span class="icon-ico-pencil ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => {
								setDeleteItemData(row?.original, () => setShowDeleteModal(true));
							}}>
							<span class="icon-ico-delete ft-18" />
						</a>
					</>
				),
			},
		],
		[],
	);

	const dataWithIDSerial =
		staffs?.data?.rows?.map((item, index) => ({
			...item,
			idSerial: (staffs?.data?.currentPage - 1) * dataLimit + index + 1,
		})) || [];

	const handleDeleteData = () => {
		deleteStaffById(
			{id: deleteItemData.staff.id},
			{
				onSuccess: () => {
					showToast("success", `Data dokter "${deleteItemData.fullName}" berhasil dihapus`, 3000);
					window.scrollTo(0, 0);
					setShowDeleteModal(false);
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	return (
		<DashboardLayout>
			<>
				<div class="text-bold text-dark mb-4">Data Staff</div>
				<SearchBox
					rightElement={<ButtonAddTable text="Tambah Staff" onClick={() => history.push("/staff/tambah")} />}
					onSearch={keyword => {
						filterStaffs({search: keyword, page: 1, limit: dataLimit});
						setSearchKeyword(keyword);
					}}
				/>

				<BasicTable
					columns={isMobile ? columnsMobile : columns}
					currentPage={staffs?.data?.currentPage}
					data={dataWithIDSerial}
					limit={dataLimit}
					loading={isLoading}
					striped={true}
					title="Data Staff"
					totalItems={staffs?.data?.totalItems}
					totalPage={staffs?.data?.totalPages}
					onLimitChange={limit => {
						filterStaffs({limit, page: 1, search: searchKeyword});
						setDataLimit(limit);
					}}
					onPageChange={selectedPage =>
						filterStaffs({page: selectedPage, limit: dataLimit, search: searchKeyword})
					}
				/>
				<ModalConfirmation
					approveLabel="Ya"
					description={`Apakah Anda yakin ingin menghapus data "${deleteItemData.fullName}"?`}
					loading={isDeletingData}
					rejectLabel="Batal"
					visible={showDeleteModal}
					onApprove={handleDeleteData}
					onClose={() => setShowDeleteModal(false)}
					onReject={() => setShowDeleteModal(false)}
				/>
			</>
		</DashboardLayout>
	);
}
